var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('center',[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/img/logo-transparente.svg"),"alt":"CETABA"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }